import React from "react";
import { ScaleLoader } from "react-spinners";

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "18%",
      }}
    >
      <ScaleLoader color={"#9b6bdb"} className="spinner" size={300} />
    </div>
  );
};

export default Loader;
